<template>
	<div
		class="session-user-card"
		:class="{'session-user-card--offline' : !status}"
	>
		<div
			class="session-user-card__header"
			@click="$emit('click')"
		>
			<AppImage
				class="avatar"
				:src="avatar"
				:fallback="require('@/assets/img/default-avatar.png')"
			/>

			<p>{{ name || '--' }}</p>
		</div>

		<div class="session-user-card__mood">
			<svg viewBox="0 0 36 36" class="mood-meter">
				<path
					ref="circle"
					class="circle"
					:class="{ 'no-stroke': !progress || progress <= 0 }"
					:stroke-dasharray="`${progress}, 100`"
					d="M18 2.0845
					a 15.9155 15.9155 0 0 1 0 31.831
					a 15.9155 15.9155 0 0 1 0 -31.831"
				/>
			</svg>

			<AppImage
				class="sticker"
				:src="`${emotionImage}`"
				:fallback="require('@/assets/img/default-emoji.png')"
			/>
		</div>

		<div class="session-user-card__emotion">{{ emotion ? this.$t(String(emotion).toLowerCase()): '--' }}</div>

        <div class="session-user-card__footer" v-if="isFitness">
			<AppImage
				:src="require('@/assets/img/card icons/calories_icon.png')"
				class="cal"
			/>

			<p>{{ `${calories || 0} Kcal` }}</p>
		</div>

		<div class="session-user-card__footer stress-wrap">
			<AppImage
				:src="`${API_URL}${stressImg}`"
				:style="`animation-duration: ${Number(Number(bpm) / 60).toFixed(2)}s;`"
				class="stress"
				:class="{
						'stress--animate' : status,
						'stess--no-data' : !stress
					}"
			/>

			<p class="stress-level">{{ stress ? this.$t(String(stress).toLowerCase()): '...' }}</p>

            <p>|</p>

			<p class="bpm" v-if="bpm">{{ `${bpm} BPM` }}</p>
			<!-- <p v-else-if="calories">{{ `${calories} Kcal` }}</p> -->
			<p class="bpm" v-else>...</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		avatar: String,
		name: String,
		emotion: String,
		emotionImg: String,
		stress: String,
		stressImg: String,
		bpm: [String, Number],
		calories: [String, Number],
		status: Boolean,
		progress: Number,
		isFitness: Boolean
	},

	data () {
		return {
			API_URL: process.env.VUE_APP_API_URL
		}
	},

	computed: {
		emotionImage () {
			return this.emotionImg ? this.API_URL + this.emotionImg : null
		}
	}
}
</script>

<style lang="scss" scoped>
.session-user-card {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	font-size: 12px;
	padding: 10px;
	box-shadow: 0 0 3px #77839529;
	background-color: #fff;

	&--offline {
		filter: grayscale(100%);
		background-color: #F0F0F7;
	}

	&__header {
		display: flex;
		justify-content: center;
		align-items: center;
        width: 100%;

		.avatar {
			width: 25px;
			height: 25px;
			background-size: cover;
			border-radius: 50%;
			margin-right: 1em;
		}

        p {
            max-width: 75%;
            overflow: hidden;
            white-space: nowrap;
        }
	}

	&__mood {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 90%;
		padding: 10px;

		.mood-meter {
			display: block;
			margin: 0 auto 0 auto;
			width: 100%;

			.circle {
				stroke: #27BBDB;
				fill: none;
				stroke-width: 1;
				stroke-linecap: round;
				stroke-dashoffset: 2s ease-in-out;
				transition: stroke-dasharray 1s ease-out;

				&.no-stroke {
					stroke-width: 0;
				}
			}

		}

		.sticker {
			position: absolute;
			border-radius: 50%;
			width: calc(75% - 10px);
			height: calc(75% - 10px);
		}
	}

	&__emotion {
		font-size: 1.1em;
		font-weight: 600;
	}

	&__footer {
        width: 90%;
		display: flex;
		align-items: center;
		margin-top: 10px;
		font-size: 0.9em;
		color: $default;

		> * {
			margin-right: .5em;
		}

        &.stress-wrap {
            margin-top: 5px;
        }

		.stress, .cal {
            margin-right: 15px;
			width: 1.3em;
			height: 1.3em;
			animation-iteration-count:  infinite;
			animation-direction:  forwards;
			animation-timing-function: ease;

			&--animate {
				animation-name: beatHeart;
			}

			&--no-data {
				filter: grayscale(100%);
				animation: none;
			}
		}

        .cal {
            height: 2.3em;
        }

	}
}

@keyframes beatHeart {
	0% {
		transform: scale(1.3);
	}

	30%, 100% {
		transform: scale(1);
	}
}
</style>
